import React from "react";
import { Table, Tag, Button, Tooltip, Modal } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const FeeTypesTable = ({ feeTypes, loading, onEdit, onDelete }) => {
  const handleDelete = (feeType) => {
    Modal.confirm({
      title: "Delete Fee Type",
      content: `Are you sure you want to delete "${feeType.name}"? This action cannot be undone.`,
      okText: "Delete",
      okType: "danger",
      onOk: () => onDelete(feeType.feeTypeId),
    });
  };

  const columns = [
    {
      title: "Fee Type",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <a onClick={() => onEdit(record)}>{text}</a>,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      render: (code) => <Tag color="blue">{code}</Tag>,
    },
    {
      title: "Is Tuition",
      dataIndex: "isTuition",
      key: "isTuition",
      align: "center",
      render: (isTuition) =>
        isTuition ? (
          <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 16 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "#d9d9d9", fontSize: 16 }} />
        ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => text || "-",
      ellipsis: true,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) => (
        <Tag color={isActive === 1 ? "green" : "red"}>
          {isActive === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div>
          <Tooltip title="Edit">
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={feeTypes}
      rowKey="feeTypeId"
      loading={loading}
      scroll={{ x: 800 }}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        showTotal: (total) => `Total ${total} fee types`,
      }}
    />
  );
};

export default FeeTypesTable;
